import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=6fddf49b&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fddf49b')) {
      api.createRecord('6fddf49b', component.options)
    } else {
      api.reload('6fddf49b', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=6fddf49b&", function () {
      api.rerender('6fddf49b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wpUmQQx5xiei/JS/comp/IncreaseNumber.vue"
export default component.exports